import React from 'react';
import { Box } from '@mui/material';
import { DoubleRing } from './motion/PageLoader';

export default function PageSuspenseFallback() {
  return (
    <Box aria-busy="true" aria-label="Loading page" sx={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <DoubleRing />
    </Box>
  );
}
